import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import AppointmentForm from "./components/appointmentForm";
import AppointmentSummary from "./components/appointmentSummary";
import { Loading } from "../../../../../utils/loading";
import { dealershipMockData } from "./mock-data";
import { useConsultantSchedulingForm } from "../../../../../hooks/useConsultantSchedulingForm";
import { fetchUserRole } from "../../../../../api/fetchUser";
import { UserRoleEnum } from "../../../../../enums/role";
import GroupConsultantAppointment from "./groupConsultantAppointment";

const Appointment = (props: any) => {
	const intl = useIntl();
	const [roleLoading, setRoleLoading] = useState(true);
	const [userRole, setUserRole] = useState<UserRoleEnum | undefined>();

	useEffect(() => {
		const loadRole = async () => {
			const role = await fetchUserRole();
			setUserRole(role);
			setRoleLoading(false);
		};
		loadRole();
	}, []);

	const {
		step, setStep,
		loading,
		appointment, setAppointment, appointmentId,
		assets,
	} = useConsultantSchedulingForm(dealershipMockData);

	if (roleLoading) return <Loading label={intl.formatMessage({ id: "intl-msg:dealership.appointment.loading" })} />;

	if (userRole === UserRoleEnum.GROUP_CONSULTANT) {
		return <GroupConsultantAppointment />;
	}

	if (loading) return <Loading label={intl.formatMessage({ id: "intl-msg:dealership.appointment.loading" })} />;

	return step === 0 ?
		<AppointmentForm
			goToSummary={() => setStep(1)}
			form={appointment}
			setForm={setAppointment}
			assets={assets}
			appointmentId={appointmentId}
		/>
		:
		<AppointmentSummary
			goBackToForm={() => setStep(0)}
			appointment={appointment}
			appointmentId={appointmentId}
		/>
};

export default Appointment;
